import cartelAnimadoVideo from '../../../../assets/CartelAnimado.mp4';
import { Panel, Stat, replayButton, secondary } from './ExperienceLayout';

function challengeMessageFor(stats) {
  const challenge = stats.challenge;
  if (!challenge) return null;
  if (challenge.status !== 'completed') {
    return 'Tu puntaje está guardado. El premio del duelo se acredita cuando ambos terminan.';
  }
  if (challenge.result === 'tie') return 'El reto terminó en empate.';
  return challenge.result === 'creator'
    ? `Ganó @${challenge.creator.username}.`
    : `Ganó @${challenge.opponent?.username}.`;
}

function AwardRow({ award }) {
  const kind = award.kind === 'first_visit' ? 'Primera visita'
    : award.kind === 'solo_play' ? 'Partida en solitario'
    : award.kind === 'achievement' ? 'Medalla'
      : award.kind === 'challenge' ? 'Reto' : 'Punto oculto';
  return (
    <p className="flex justify-between border-b border-white/15 py-2 text-xs text-[#C5E6A0]">
      <span>{kind}</span>
      <strong className="text-[#F7E04B]">+{award.points}</strong>
    </p>
  );
}

export default function ResultScreen({ stats, mode, location, scoringFrozen, cartelVisible, cartelFading, onHideCartel, onNavigate, onStart }) {
  const isTournament = mode === 'tournament';
  const tournamentMessage = isTournament
    ? `Tu puntaje del torneo quedó registrado: ${stats.score.toLocaleString()} puntos`
      + `${stats.accuracy == null ? '' : ` con ${stats.accuracy}% de precisión`}. Gana el mayor puntaje; el empate lo rompe la precisión.`
    : null;
  const message = challengeMessageFor(stats)
    || tournamentMessage
    || (stats.isVictory
      ? `${location || 'Toluca'} ya reconoce tu paso.`
      : 'Escucha el golpe, encuentra el ritmo y vuelve a intentarlo.');
  const title = mode === 'vs' ? 'Resultado del reto'
    : isTournament ? 'Puntaje del torneo'
      : stats.isVictory ? 'Zona maldecida' : 'El pulso cayó';

  return (
    <Panel>
      <img src="/banner-nacanaca.jpg" alt="La Maldición Ñaca Ñaca" className="mx-auto h-auto w-full object-contain" />
      <p className="mt-7 text-[10px] font-black uppercase tracking-[.25em] text-[#F7E04B]">Registro concluido</p>
      <h1 className="mt-2 font-display text-4xl uppercase leading-none text-[#F7E04B]">{title}</h1>
      <p className="mt-3 text-sm text-[#C5E6A0]">{message}</p>
      <div className="mt-6 grid grid-cols-2 border-y border-[#F7E04B]/45">
        <Stat label="Puntaje de juego" value={stats.score.toLocaleString()} />
        <Stat label="Puntos oficiales" value={`+${stats.officialPoints || 0}`} />
        <Stat label="Precisión" value={stats.accuracy == null ? '—' : `${stats.accuracy}%`} />
        <Stat label="Mejor combo" value={stats.maxCombo ?? '—'} />
      </div>
      {scoringFrozen && !isTournament && (
        <p className="mt-4 border border-[#F7E04B]/45 bg-black/60 p-3 text-xs leading-5 text-[#F7E04B]" role="status">
          El festival terminó: el ranking quedó congelado y las partidas ya no suman puntos oficiales.
          Puedes seguir jugando por gusto.
        </p>
      )}
      {stats.awards?.length > 0 && (
        <div className="mt-4 text-left">
          {stats.awards.map((award) => <AwardRow key={`${award.kind}-${award.sourceKey}`} award={award} />)}
        </div>
      )}
      {mode === 'vs' && (
        <button onClick={() => onNavigate('pending')} className={`${secondary} mt-5`}>Ver mis duelos</button>
      )}
      {mode !== 'vs' && mode !== 'tournament' && (
        <button onClick={() => onStart('solo')} className={`${replayButton} mt-7`}>Volver a jugar</button>
      )}
      <button onClick={() => onNavigate('ranking')} className={`${secondary} ${mode === 'vs' ? 'mt-7' : 'mt-3'}`}>
        {mode === 'tournament' ? 'Ver ranking del torneo' : 'Ver ranking'}
      </button>
      <button onClick={() => onNavigate('hub')} className="mt-6 text-xs font-bold uppercase tracking-widest text-[#F7E04B] underline underline-offset-4">
        Volver al mapa
      </button>
      {cartelVisible && (
        <div
          className="fixed inset-0 z-[70] grid place-items-center bg-black px-5"
          style={{ opacity: cartelFading ? 0 : 1, transition: 'opacity 0.6s ease', pointerEvents: cartelFading ? 'none' : 'auto' }}
          role="dialog"
          aria-label="Cartel animado"
          onClick={onHideCartel}
        >
          <div className="w-full max-w-sm text-center">
            <video
              src={cartelAnimadoVideo}
              autoPlay
              muted
              playsInline
              preload="auto"
              className="max-h-[70vh] w-full rounded-sm border border-[#F7E04B]/45 bg-black object-contain"
            >
              Tu navegador no puede reproducir el cartel animado.
            </video>
            <p className="mt-4 text-[11px] font-bold uppercase tracking-[.18em] text-white/60">Toca para continuar</p>
          </div>
        </div>
      )}
    </Panel>
  );
}
